var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 2.94856C6.10564 2.94856 2.94868 6.10552 2.94868 9.99984C2.94868 13.8942 6.10564 17.0511 9.99996 17.0511C13.8943 17.0511 17.0512 13.8942 17.0512 9.99984C17.0512 6.10552 13.8943 2.94856 9.99996 2.94856ZM1.66663 9.99984C1.66663 5.39746 5.39759 1.6665 9.99996 1.6665C14.6023 1.6665 18.3333 5.39746 18.3333 9.99984C18.3333 14.6022 14.6023 18.3332 9.99996 18.3332C5.39759 18.3332 1.66663 14.6022 1.66663 9.99984ZM9.35893 6.58103C9.35893 6.22701 9.64593 5.94001 9.99996 5.94001H10.0085C10.3625 5.94001 10.6495 6.22701 10.6495 6.58103C10.6495 6.93506 10.3625 7.22206 10.0085 7.22206H9.99996C9.64593 7.22206 9.35893 6.93506 9.35893 6.58103ZM8.50423 9.99984C8.50423 9.64581 8.79123 9.35881 9.14526 9.35881H9.99996C10.354 9.35881 10.641 9.64581 10.641 9.99984V12.7776H10.8547C11.2087 12.7776 11.4957 13.0646 11.4957 13.4186C11.4957 13.7727 11.2087 14.0597 10.8547 14.0597H9.99996C9.64593 14.0597 9.35893 13.7727 9.35893 13.4186V10.6409H9.14526C8.79123 10.6409 8.50423 10.3539 8.50423 9.99984Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkInfo);
export default __webpack_public_path__ + "static/media/dark-info.d2ee60b71d94e24b275b6b4442e89af2.svg";
export { ForwardRef as ReactComponent };